// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__4V7E2","itemTitle":"ClientEmergencyInfo_itemTitle__gw_wW","itemText":"ClientEmergencyInfo_itemText__3dUX6"};